import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon(
        $ids: [String]
        $category_ids: [String]
        $shop_ids: [String]
        $codes: [String]
        $user_ids: [String]
        $unit_ids: [String]
        $title: String
        $viewed_on: String
        $is_active: Int
        $usable: Int
        $for_admin: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        coupon(
          ids: $ids
          category_ids: $category_ids
          shop_ids: $shop_ids
          codes: $codes
          user_ids: $user_ids
          unit_ids: $unit_ids
          title: $title
          viewed_on: $viewed_on
          is_active: $is_active
          usable: $usable
          for_admin: $for_admin
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            status
            amount
            end_date
            is_active
            start_date
            check_messages {
              text
            }
            assignment_type
            products_shop {
              id
            }
            product_categories {
              id
            }
            users {
              id
            }
            shop {
              id
              title
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteCoupon',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteCoupon($ids: [String]!) {
        deleteCoupon(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon($ids: [String]) {
        coupon(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon($ids: [String]) {
        coupon(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
